import React from "react";
import { NavLink, withRouter, Link } from "react-router-dom";
import { gql } from "@apollo/client";
import { apolloClient } from "../../../index";

import "./FolderListCard.scss";
import pinnedImage from "../../../assets/icons/pinned.svg";
import pinnableImage from "../../../assets/icons/pinable.svg";
import folderColor1 from "../../../assets/icons/small_folder_icon/folder_color-1.svg";
import folderColor2 from "../../../assets/icons/small_folder_icon/folder_color-2.svg";
import folderColor3 from "../../../assets/icons/small_folder_icon/folder_color-3.svg";
import folderColor4 from "../../../assets/icons/small_folder_icon/folder_color-4.svg";
import folderColor5 from "../../../assets/icons/small_folder_icon/folder_color-5.svg";
import folderColor6 from "../../../assets/icons/small_folder_icon/folder_color-6.svg";
import folderColorPrimary from "../../../assets/icons/small_folder_icon/folder_primary.svg";
import { notify } from "../../Notify/Notify";
import { compose } from "redux";
import {
  mapDispatchToProps,
  mapStateToProps,
} from "../../../common/UserDataReducer";
import { connect } from "react-redux";

const colors = [
  null,
  folderColor1,
  folderColor2,
  folderColor3,
  folderColor4,
  folderColor5,
  folderColor6,
  folderColorPrimary,
];

class FolderListCard extends React.Component {
  state = {
    data: {
      subFolders: this.props.subFolders[this.props.item.id] || [],
      hoverId: "",
      data: {},
    },
    showSubFolders: false,
  };

  componentDidMount() {
    if (this.props.isArchived) {
      let newSubFolders = {
        subFolders: this.props.item.subfolders,
      };
      this.setState({
        data: newSubFolders,
      });
    }
  }

  handleShowSubFolders() {
    if (this.state.showSubFolders) {
      this.setState({
        showSubFolders: false,
      });
      return;
    }
    const subFolders = this.props.subFolders[this.props.item.id];
    if (subFolders) {
      this.setState({
        data: { subFolders },
        showSubFolders: true,
      });
    } else {
      const variables = {
        parentFolderId: this.props.item.id,
      };
      apolloClient
        .query({
          query: gql`
            query subFolder($parentFolderId: UUID!) {
              subFolders(parentFolderId: $parentFolderId, skip: 0) {
                folderId: id
                id
                title
                approvalRequired
                approvalLevels {
                  id
                  name
                  users {
                    id
                    isActive
                    username
                    firstName
                    lastName
                    email
                    profile {
                      imageUrl: image
                    }
                  }
                  sequence
                }
                description
                instruction
                color {
                  id
                  name
                }
                createdBy {
                  id
                  username
                  firstName
                  lastName
                  email
                  profile {
                    image
                    role {
                      id
                      name
                    }
                  }
                }
                modifiedTs
                parentFolder {
                  id
                  title
                }
                documentSet {
                  id
                  file
                  title
                  inTrash
                  documentType {
                    id
                    title
                  }
                }
                sharedFolder {
                  id
                  user {
                    id
                    email
                    username
                    firstName
                    lastName
                    profile {
                      image
                      role {
                        id
                        name
                      }
                    }
                  }
                  userRole {
                    id
                    name
                  }
                }
                pinnedFolder {
                  user {
                    id
                  }
                  folder {
                    id
                    title
                  }
                }
              }
            }
          `,
          variables: variables,
        })
        .then((result) => {
          const subFolders = {
            ...this.props.subFolders,
            [this.props.item.id]: result.data.subFolders,
          };
          this.props.updateFolders({
            rootFolders: this.props.rootFolders,
            subFolders,
          });
          this.setState({
            data: result.data,
            showSubFolders: true,
          });
        })
        .catch((e) => {
          const title = "Error";
          const detail = e.message;
          const type = "error";
          notify(title, detail, type);
        });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.setState({
        data: {
          ...this.state.data,
          subFolders: this.props.subFolders[this.props.item.id] || [],
        },
      });
    }
  }

  getPinned = (id, pinFolder) => {
    const pinnedClass = this.state.hoverId === id ? "show" : "hide";
    const updatedPinFolder = pinFolder.filter(
      (item) => item.user.id === this.props.currentUserInfo.id
    );
    return updatedPinFolder.length > 0 ? (
      <div className={["pinned-box", "d-flex"].join(" ")}>
        <img alt="PinnedIcon" src={pinnedImage} className="img-fluid" />
      </div>
    ) : (
      <div className={["pinned-box", "d-flex", pinnedClass].join(" ")}>
        <img alt="PinnedIcon" src={pinnableImage} className="img-fluid" />
      </div>
    );
  };

  pinHandler = (pinId, length, folderTitle, folderType) => {
    const variables = {
      folderId: pinId,
    };
    let PIN_API =
      length > 0
        ? `mutation UnPinFolder($folderId: UUID!) {
          unPinFolder(folderId: $folderId) {
            success
          }
        }`
        : `mutation PinFolder($folderId: UUID!) {
          pinFolder(folderId: $folderId) {
            success
          }
        }`;

    apolloClient
      .mutate({
        mutation: gql`
          ${PIN_API}
        `,
        variables: variables,
      })
      .then((result) => {
        if (folderType === "root") {
          this.props.updatePinFolder({
            folder: {
              id: pinId,
              title: folderTitle,
            },
            user: {
              id: this.props.currentUserInfo.id,
            },
          });
        } else {
          const newStateObj = { ...this.state };
          const updatedFoldersForUser = [...newStateObj.data.subFolders];
          let updatePin = {};
          let parentId;
          updatedFoldersForUser.map((folder) => {
            if (folder.id === pinId) {
              if (folder.pinnedFolder.length === 0) {
                folder.pinnedFolder.push({
                  folder: {
                    id: pinId,
                    title: folderTitle,
                  },
                  user: {
                    id: this.props.currentUserInfo.id,
                  },
                });
                updatePin = folder;
              } else {
                folder.pinnedFolder = [];
                parentId = folder.parentFolder.id;
              }
            }
            return true;
          });
          this.props.getRecentPin(updatePin, pinId, parentId);
          this.setState({ ...newStateObj });
        }
        // notify on success
        const detail = "Success";
        const title =
          length > 0
            ? `${folderTitle} unpinned successfully!`
            : `${folderTitle} Folder pinned successfully!`;
        const type = "success";
        notify(detail, title, type);
      })
      .catch((e) => {
        // notify for error
        const detail = "Error";
        const title = e.message;
        const type = "error";
        notify(detail, title, type);
      });
  };

  render() {
    return (
      <div className="mt-3 dropdown-wraper">
        <button
          className={`folder-link d-flex align-items-center ${
            this.state.data.subFolders.length > 0 && this.state.showSubFolders
              ? "focused"
              : ""
          }`}
          onMouseOver={() => {
            this.setState({ hoverId: this.props.item.id });
          }}
          onMouseOut={() => {
            this.setState({ hoverId: "" });
          }}
        >
          <Link
            to={
              this.props.isArchived
                ? `/archives/${this.props.item.id}/`
                : `/files/${this.props.item.id}/`
            }
          >
            <img
              className="pr-2"
              src={colors[this.props.color]}
              alt="folder primary"
            />
          </Link>
          <div className="label-container">
            <Link
              className="dropdown-label"
              to={
                this.props.isArchived
                  ? `/archives/${this.props.item.id}/`
                  : `/files/${this.props.item.id}/`
              }
            >
              {this.props.folderName}
            </Link>
            {!this.props.isArchived ? (
              <div
                className="pinned"
                onClick={() =>
                  this.pinHandler(
                    this.props.item.id,
                    this.props.item.pinnedFolder.length,
                    this.props.folderName,
                    "root"
                  )
                }
              >
                {this.getPinned(
                  this.props.item.id,
                  this.props.item.pinnedFolder
                )}
              </div>
            ) : null}
          </div>
          {this.props.item.hasSubFolders ? (
            <div
              className="folder-down-arrow"
              onClick={() => {
                this.handleShowSubFolders();
              }}
            ></div>
          ) : (
            <div className="dummy-content"></div>
          )}
        </button>

        {this.state.data.subFolders.length > 0 && this.state.showSubFolders ? (
          <div className="folder-dropdown-menu py-3">
            {this.state.data.subFolders.map((sKey, index) => (
              <div
                key={index}
                className="dropdown-item pl-5 inner-item"
                onMouseOver={() => {
                  this.setState({ hoverId: sKey.id });
                }}
                onMouseOut={() => {
                  this.setState({ hoverId: "" });
                }}
              >
                <NavLink
                  className="d-flex align-items-center"
                  to={
                    this.props.isArchived
                      ? `/archives/${this.props.item.id}/${sKey.id}`
                      : `/files/${this.props.item.id}/${sKey.id}`
                  }
                >
                  <img
                    className="pr-2"
                    src={colors[sKey.color.id]}
                    alt="folder primary"
                  />
                  <div className="dropdown-label">{sKey.title}</div>
                </NavLink>
                {!this.props.isArchived ? (
                  <div
                    className="pinned"
                    onClick={() =>
                      this.pinHandler(
                        sKey.id,
                        sKey.pinnedFolder.length,
                        sKey.title,
                        "sub"
                      )
                    }
                  >
                    {this.getPinned(sKey.id, sKey.pinnedFolder)}
                  </div>
                ) : null}
              </div>
            ))}
          </div>
        ) : null}
      </div>
    );
  }
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(FolderListCard);
